/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Page_Compare_TitleInputs */

const en_pc_page_compare_title = /** @type {(inputs: Pc_Page_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft vs Photoshop: Features, Price and Verdict`)
};

const zh_pc_page_compare_title = /** @type {(inputs: Pc_Page_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft 对比 Photoshop：功能、价格与结论`)
};

/**
* | output |
* | --- |
* | "PhotoCraft vs Photoshop: Features, Price and Verdict" |
*
* @param {Pc_Page_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_page_compare_title = /** @type {((inputs?: Pc_Page_Compare_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Page_Compare_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_page_compare_title(inputs)
	return zh_pc_page_compare_title(inputs)
});
export { pc_page_compare_title as "pc.page.compare.title" }